import { Box, styled, Typography, useMediaQuery, useTheme } from '@mui/material'
import DiscordIcon from 'components/Icons/MediaIcons/Discord'
import InstagramIcon from 'components/Icons/MediaIcons/Instagram'
import TwitterIcon from '@mui/icons-material/Twitter'
import BlackBackTop from 'components/BackTop/BlackBackTop'
import TelegramIcon from '@mui/icons-material/Telegram'
import { useMemo } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

const FooterBox = styled('footer')`
  display: flex;
  align-items: center;
  color: #aaaaaa;
  padding-top: 100px;
  padding-bottom: 120px;
  position: relative;
  background-color: ${props => props.theme.colors.background.article};
  z-index: 11;
  @media (max-width: 900px) {
    .footer-menu {
      display: block;
      text-align: center;
      margin-top: 56px;
      .MuiBox-root {
        width: 100%;
        margin-bottom: 32px;
      }
      p {
        width: 100%;
      }
    }
  }
  .title {
    font-weight: 500;
    font-size: 16px;
    line-height: 20px;
    margin-bottom: 48px;
  }
  .sub-title {
    font-weight: 400;
    font-size: 16px;
    line-height: 20px;
    margin-bottom: 32px;
    cursor: pointer;
  }
  > div {
    padding: 0 120px;
    width: 100%;
    display: flex;
    align-items: start;
    justify-content: space-between;
    gap: 7rem;
    @media (max-width: 900px) {
      flex-direction: column-reverse;
      align-items: center;
      justify-content: center;
      text-align: center;
      .toBottom {
        order: 1;
        margin-right: unset;
      }
      .toBottom ~ div {
        margin-right: unset;
      }
    }
    svg:first-of-type,
    svg:last-of-type {
      font-size: 28px;
    }
    a:not(:first-of-type) {
      margin-left: 60px;
    }
    svg {
      cursor: pointer;
      font-size: 23px;
      width: 23px;
      height: 23px;
      color: ${props => props.theme.colors.svg.normal};
      &:hover {
        color: ${props => props.theme.colors.svg.active};
      }
    }
  }
  @media (max-width: 1200px) {
    padding: 100px 51px 152px 51px;
    .title {
      font-size: 16px;
      line-height: 20px;
      margin-bottom: 48px;
    }
    .sub-title {
      font-size: 16px;
      line-height: 20px;
      margin-bottom: 32px;
      cursor: pointer;
    }
    > div {
      padding: 0 24px;
      a:not(:first-of-type) {
        margin-left: 60px;
      }
    }
    .toBottom {
      margin-right: 40px;
    }
    .toBottom ~ div {
      margin-right: 40px;
    }
  }
  @media (max-width: 900px) {
    padding: 56px 51px;
    > div {
      padding: 0;
      gap: 0;
    }
  }
`

export default function Footer() {
  const location = useLocation()
  const theme = useTheme()
  const md = useMediaQuery(theme.breakpoints.down('md'))

  const checkHidden = useMemo(() => {
    const hiddenPagePathList = ['game/midgardsaga/event', '/login', 'game/OathofPeak/earlyaccess', 'referral']
    const mapHiddenList = hiddenPagePathList.some(path => location.pathname.indexOf(path) > -1)
    return !mapHiddenList
  }, [location.pathname])

  const navigate = useNavigate()
  return (
    <>
      {checkHidden && (
        <FooterBox>
          <div>
            <Box display={'flex'} className="footer-menu">
              {!md && (
                <Box sx={{ marginRight: '40px' }}>
                  <Typography variant="body1" fontWeight="500">
                    © {new Date().getFullYear()} Yeeha Games
                  </Typography>
                </Box>
              )}
              {/* <Box sx={{ marginRight: '40px' }}>
                <Typography
                  onClick={() => {
                    window.open('https://www.linkedin.com/company/yeehagames/')
                  }}
                  variant="body1"
                  fontWeight="500"
                  sx={{ cursor: 'pointer' }}
                >
                  Careers
                </Typography>
              </Box> */}
              <Box sx={{ marginRight: '40px' }}>
                <Typography variant="body1" sx={{ cursor: 'pointer' }} fontWeight="500">
                  <a href="mailto:support@yeehagames.com" title="email" style={{ color: theme.colors.svg.normal }}>
                    Contact Us
                  </a>
                </Typography>
              </Box>
              <Box sx={{ marginRight: '40px' }}>
                <Typography
                  variant="body1"
                  sx={{ cursor: 'pointer' }}
                  fontWeight="500"
                  onClick={() => {
                    navigate('protocol/YeehaGames')
                  }}
                >
                  About
                </Typography>
              </Box>
              <Box sx={{ marginRight: '40px' }}>
                <Typography
                  variant="body1"
                  sx={{ cursor: 'pointer' }}
                  fontWeight="500"
                  onClick={() => {
                    navigate('terms')
                  }}
                >
                  Terms and Conditions
                </Typography>
              </Box>
              <Box sx={{ marginRight: '40px' }}>
                <Typography
                  variant="body1"
                  sx={{ cursor: 'pointer' }}
                  fontWeight="500"
                  onClick={() => {
                    navigate('privacy-policy')
                  }}
                >
                  Privacy Policy
                </Typography>
              </Box>
              <Box>
                <Typography
                  variant="body1"
                  sx={{ cursor: 'pointer' }}
                  fontWeight="500"
                  onClick={() => {
                    navigate('community-guidelines')
                  }}
                >
                  Community Guidelines
                </Typography>
              </Box>
              {md && (
                <Box sx={{ marginTop: '56px' }}>
                  <Typography variant="body1" fontWeight="500">
                    © {new Date().getFullYear()} Yeeha Games
                  </Typography>
                </Box>
              )}
              {/* <Box sx={{ marginRight: '80px' }}>
                <p className="title">About Us</p>
                <p
                  className="sub-title"
                  onClick={() => {
                    navigate('/protocol/terms')
                  }}
                >
                  Why Yeeha
                </p>
                <p
                  className="sub-title"
                  onClick={() => {
                    navigate('/protocol/privacy')
                  }}
                >
                  Careers
                </p>
              </Box>
              <Box sx={{ marginRight: '80px' }}>
                <p className="title">Legal and Privacy</p>
                <p
                  className="sub-title"
                  onClick={() => {
                    navigate('/protocol/terms')
                  }}
                >
                  Terms of Use
                </p>
                <p
                  className="sub-title"
                  onClick={() => {
                    navigate('/protocol/privacy')
                  }}
                >
                  Privacy Policy
                </p>
              </Box>
              <Box sx={{ marginRight: '80px' }}>
                <p className="title">Support</p>
                <p
                  className="sub-title"
                  onClick={() => {
                    navigate('/protocol/terms')
                  }}
                >
                  About
                </p>
                <p
                  className="sub-title"
                  onClick={() => {
                    navigate('/protocol/privacy')
                  }}
                >
                  Contact Us
                </p>
              </Box> */}
            </Box>
            <Box>
              {/* <p className="title">Our Community</p> */}
              <Box display={'flex'} alignItems={'center'} marginTop="8px">
                <a href="https://discord.com/invite/Jqv2FdgEcH" target={'_blank'} rel="noreferrer">
                  <DiscordIcon />
                </a>
                <a href="https://t.me/realyeehagames" target={'_blank'} rel="noreferrer">
                  <TelegramIcon />
                </a>
                <a href="https://twitter.com/YeehaGames" target={'_blank'} rel="noreferrer">
                  <TwitterIcon />
                </a>
                <a href="https://www.instagram.com/yeehagames/" target={'_blank'} rel="noreferrer">
                  <InstagramIcon />
                </a>
              </Box>
            </Box>
          </div>
          {!md && document.documentElement.scrollTop < document.body.clientHeight * 1.5 && (
            <BlackBackTop></BlackBackTop>
          )}
        </FooterBox>
      )}
    </>
  )
}
